import { mergeHeaders, setAuthorizationHeader } from '../shared';
import { shouldJsonStringifyBody } from './body';
import { responseTypes } from './constants';
export const buildHeaders = ({ defaultHeaders, overrideHeaders, token, body, responseType, }) => {
    const headers = mergeHeaders(defaultHeaders, overrideHeaders);
    setAuthorizationHeader(headers, token);
    if (!headers.has('Accept')) {
        headers.set('Accept', responseType === responseTypes.Json ? 'application/json' : '*/*');
    }
    if (body !== undefined &&
        body !== null &&
        shouldJsonStringifyBody(body) &&
        !headers.has('Content-Type')) {
        headers.set('Content-Type', 'application/json');
    }
    return headers;
};
